import { graphql, useStaticQuery } from 'gatsby';

export function usePageInterlinking(pageName, pageLang) {
  const {
    allPageInterlinkingJson: { nodes: items },
  } = useStaticQuery(graphql`
    query {
      allPageInterlinkingJson {
        nodes {
          lang
          pages {
            page
            items {
              title
              description
              experience {
                list
                listItemTag
                title
              }
              link
            }
          }
        }
      }
    }
  `);

  const { pages } = items.find(({ lang }) => lang === pageLang);

  return pageName ? pages.find(({ page }) => page === pageName)?.items : null;
}
